import { OldHeading, Image } from '@gassan-ui'
import { getKontentImage } from '@lib/kontent'
import { TudorLandingpage } from '@lib/kontent/models/TudorLandingpage'
import { FC } from 'react'

type TudorLandingPageBannerProps = {
  title: string
  image: TudorLandingpage['prefooter_background_image']
}

export const TudorLandingPageBanner: FC<TudorLandingPageBannerProps> = ({ title, image }) => {
  return (
    <div className="relative m-auto flex aspect-[2/1] w-full max-w-[2500px] items-center justify-center md:aspect-[4/1]">
      <Image
        className="absolute left-0 top-0 h-full w-full"
        sources={[
          getKontentImage(image.value[0].url, { width: 768 }),
          getKontentImage(image.value[0].url, { width: 768 }),
          getKontentImage(image.value[0].url, { width: 1200 }),
          getKontentImage(image.value[0].url, { width: 2000 }),
          getKontentImage(image.value[0].url, { width: 2500 }),
        ]}
        placeholderSrc={getKontentImage(image.value[0].url, { width: 20 })}
        alt={image.value[0].description as string}
      />

      <div className="z-10 m-auto w-full max-w-[800px] px-4 text-center">
        <OldHeading variant="h2" as="h2" color="white" mb="3" className="whitespace-pre-line">
          {title}
        </OldHeading>
      </div>
    </div>
  )
}
